module.exports = __webpack_public_path__ + "static/strategy-31d61a44d8063d2c198461684dc80430.png";